export const CALCULATE_TAX ="CALCULATE_TAX";
export const SHOW_GRADUATED_RATE = "SHOW_GRADUATED_RATE";
export const GROSS_TO_ZERO = "GROSS_TO_ZERO";
export const ALLOWANCE_TO_ZERO = "ALLOWANCE_TO_ZERO";
export const  CHANGE_GROSS_VALUE = "CHANGE_GROSS_VALUE";
export const CHANGE_ALLOWANCE_VALUE = "CHANGE_ALLOWANCE_VALUE";